import { IonFooter } from '@ionic/react';
import styled from 'styled-components';

export const LureScreenFooterStyles = styled(IonFooter)`
  flex-direction: column;
`;
